module.exports = __webpack_public_path__ + "img/ci.26a62321.svg";